/**
 * Utility functions for tracking events and errors
 */

import { useAnalytics } from "../hooks/useAnalytics";

/**
 * Hook for tracking field errors in the form
 */
export const useFieldErrorTracking = () => {
  const { track } = useAnalytics();

  return (fieldName: string, validationType: string = "blur") => {
    track("lp.contact_form.field_error", {
      field_name: fieldName,
      validation_type: validationType,
      form_type: "contact",
    });
  };
};
